import {
  appointments as getAppointmentsApi,
  appointment as getAppointmentApi,
  updateAppointment as updateAppointmentApi,
  fetchAppointments as fetchAppointmentsApi,
  getPatientAppointments as getPatientAppointmentsApi
} from './api';
import { mapAppointment } from './helper';

let getAppointments = (params) => dispatch => {
  return getAppointmentsApi(params).then((response) => ({
    ...response,
    data: response.data.map((appointment) => mapAppointment(appointment.attributes)),
  }))
}

let getAppointment = (id) => dispatch => {
  return getAppointmentApi(id).then((response) => ({
    ...response,
    data: mapAppointment(response.data.attributes),
  }))
}

let updateAppointment = (id, actionType) => dispatch => {
  return updateAppointmentApi(id, actionType)
}

let fetchAppointments = () => dispatch => {
  return fetchAppointmentsApi()
}

let getPatientAppointments = (params = {}) => dispatch => {
  return getPatientAppointmentsApi(params)
}

export {
  getAppointments,
  getAppointment,
  updateAppointment,
  fetchAppointments,
  getPatientAppointments
}
